export default {
    computed: {
        client() {
            return this.$store.getters['mycover/getClient'];
        },
        quote_id() {
            return this.$store.getters['calculators/getQuoteId'];
        },
        benefits() {
            return this.$store.getters['mycover/getBenefits'];
        },
        benefits_requested() {
            return this.$store.getters['mycover/getBenefitsRequested'];
        },
        age_range() {
            return this.$store.getters['mycover/getAgeRange'];
        },

        benefactors() {
            return this.$store.getters['mycover/getBenefactor'];
        },
        beneficiaries() {
            return this.$store.getters['mycover/getBeneficiaries'];
        },
        lpps() {
            return this.$store.getters['mycover/getLpp'];
        },
        explorer_options() {
            return this.$store.getters['mycover/getExplorerOptions'];
        },

        my_ability_lock: {
            set(value) {
                this.$store.commit('mycover/setMyAbilityLock', value);
            },
            get() {
                return this.$store.getters['mycover/getMyAbilityLock'];
            }
        },

        summaryShortFallText() {
            let text = ' - ';

            if (this.benefits_requested) {
                text += this.benefits.productIndemnificationShortfallPercentage.value > 0 ? 'With Shortfall' : 'No Shortfall';
            }

            return text;
        },

        intermediaryId() {
            let url = new window.domurl;

            if (typeof url.query.intermediary !== 'undefined') {
                return url.query.intermediary;
            }

            return null;
        }
    },

    methods: {
        getLppLabel(id) {
            let label = '';

            this.lpps.forEach((lpp_option) => {
                if (parseInt(id) === parseInt(lpp_option.id)) {
                    label = lpp_option.label;
                }
            });

            return label;
        },
        getBenefactorLabel(id) {
            let label = '';

            this.benefactors.forEach((benefactor_option) => {
                if (parseInt(id) === parseInt(benefactor_option.id)) {
                    label = benefactor_option.label;
                }
            });

            return label;
        }
    }
};
